export default {
      id: "status_fuel-usage",
      viewBox: "0 0 27 27",
      url: __webpack_public_path__ + "img/icons.svg#status_fuel",
      toString: function () {
        return this.url;
      }
    }